import React, { Component } from 'react';
import './DarkBlue.css';
import { Parallax } from 'react-scroll-parallax';

class DarkBlue extends Component {
  render() {
    return (
    	<div className="space">
	        	<div className="redObject" />
	    	<div className="blueBackground">
	    	<Parallax
	        className="custom-class"
	        offsetYMax={20 + '%'}
	        offsetYMin={-70 + '%'}
	        slowerScrollRate
	        tag="figure"
		    >
	        	<div className="prvni">Ty budeš vše vědět<br></br><span style={{marginRight: "-420px", fontSize: "120" + "px", fontWeight: "bold"}} className="font-weight-bold">první.</span></div>
	    	</Parallax>
	      </div>
	     </div>
    );
  }
}

export default DarkBlue;